module.exports = __webpack_public_path__ + "static/img/Bicon3.503cd10f.png";